import { useEffect } from "react";
import ViewMoreButton from "./ViewMore";
import { useNavigate } from "react-router-dom";
import useReferredPatients from "../../../hooks/useReferredPatients";
import PatientLogCard from "./PatientLogCard";
import emptyState from "../../../assets/images/empty-state.svg";

const PatientReferrals: any = () => {
  const navigate = useNavigate();
  const { referredPlanData, resetAndFetch, loader } = useReferredPatients();

  useEffect(() => {
    resetAndFetch();
  }, [resetAndFetch]);

  const handleViewMore = () => {
    navigate("/patient-logs");
  };

  return (
    <section className="flex flex-col w-full p-4">
      <header className="flex flex-col justify-center w-full">
        <h2 className="gap-2 self-stretch w-full text-xl font-semibold leading-snug text-gray-800 text-left">
          Patients Referred
        </h2>
      </header>
      {loader ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
          <span className="ml-3 text-gray-600">Loading patients...</span>
        </div>
      ) : !!referredPlanData?.length ? (
        <>
          <main>
            {referredPlanData?.slice(0, 2)?.map((patient, index) => (
              <PatientLogCard key={`${patient.id}-${index}`} patient={patient} />
            ))}
          </main>
          <ViewMoreButton onclick={handleViewMore} />
        </>
      ) : (
        <section className="flex flex-col w-full pb-6 pl-6 pr-6">
          <img
            loading="lazy"
            src={emptyState}
            alt=""
            className="object-contain self-center max-w-full aspect-[1.25]"
          />
          <div className="flex flex-col justify-center w-full">
            <div className="flex flex-col justify-center items-center w-full">
              <h2 className="text-2xl font-semibold leading-none text-gray-800">
                No patients found!
              </h2>
            </div>
          </div>
        </section>
      )}
    </section>
  );
};

export default PatientReferrals;
